<template>
  <div>
    <Header :selectedApp="selectedApp"></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <h2>Leagues</h2>
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <a role="button" class="procricket-btn mb-3" @click="redirectToCreate">Create New Entry</a>
          </div>
          <input type="text" class="form-control mb-3" placeholder="Search in leagues..." v-model="searchText" style="width: 20%; position: relative; ">
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
            <tr>
              <th class="col-1" @click="toggleSort('leagueId')">League Id</th>
              <th class="col-1" @click="toggleSort('caption')">Caption</th>
              <th class="col-1" @click="toggleSort('description')">Description</th>
              <th class="col-1" @click="toggleSort('logoFilename')">Logo Filename</th>
              <th class="col-1" @click="toggleSort('logoAltText')">Logo Alt Text</th>
              <th class="col-1" @click="toggleSort('application')">Application</th>
              <th class="col-1" @click="toggleSort('status')">Status</th>
              <th class="col-1" @click="toggleSort('active')">Active</th>
              <th class="col-1">Edit</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="config in sortData" :key="config.leagueId">
              <td class="col-1 text-truncate" v-html="truncateText(config.leagueId, 30)" @click="selectText" :data-text="config.leagueId"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.caption, 30)" @click="selectText" :data-text="config.caption"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.description, 30)" @click="selectText" :data-text="config.description"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.logoFilename, 30)" @click="selectText" :data-text="config.logoFilename"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.logoAltText, 30)" @click="selectText" :data-text="config.logoAltText"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.application, 30)" @click="selectText" :data-text="config.application"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.status, 30)" @click="selectText" :data-text="config.status"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.active, 30)" @click="selectText" :data-text="config.active"></td>
              <td class="col-1 centered">
                <router-link :to="{ name: 'LeagueEdit', params: { id: config.leagueId, ...config } }" class="procricket-btn">
                  Edit
                </router-link>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import AdminService from "@/services/admin-service";
import Header from "@/components/Header.vue";
import Cookies from "js-cookie";

export default {
  name: "Leagues",
  components: {
    Header,
  },
  data() {
    return {
      searchText: '',
      LeaguesList: [],
      sortColumn: '',
      sortDirection: 'asc',
      selectedApp: ''
    };
  },
  computed: {
    filteredLeaguesList() {
      const search = this.searchText.toLowerCase().trim();
      let filteredList = this.LeaguesList.filter((config) => {
        return (
            (config.leagueId && config.leagueId.toString().includes(search)) ||
            (config.caption && config.caption.toString().toLowerCase().includes(search)) ||
            (config.description && config.description.toString().toLowerCase().includes(search)) ||
            (config.logoFilename && config.logoFilename.toString().toLowerCase().includes(search)) ||
            (config.logoAltText && config.logoAltText.toString().toLowerCase().includes(search)) ||
            (config.application && config.application.toString().toLowerCase().includes(search)) ||
            (config.status && config.status.toString().includes(search)) ||
            (config.active && config.active.toString().includes(search))
        );
      });

      if (this.sortColumn) {
        const direction = this.sortDirection === 'asc' ? 1 : -1;
        filteredList = filteredList.sort((a, b) => {
          const valueA = a[this.sortColumn];
          const valueB = b[this.sortColumn];

          if (valueA < valueB) return -1 * direction;
          if (valueA > valueB) return 1 * direction;
          return 0;
        });
      }
      //Show only the elements that belong to the selected application
      if (this.selectedApp !== '') {
        filteredList = filteredList.filter(item => item.application === this.selectedApp);
      }
      return filteredList;
    },
    sortData() {
      return this.filteredLeaguesList;
    },
  },
  created() {
    this.doLoadLeagues();
    document.addEventListener('click', (event) => this.handleClickAnywhere(event));

    const appCookie = Cookies.get('application');
    if (appCookie) {
      this.selectedApp = appCookie;
    }

    this.sortColumn = 'leagueId';
  },
  methods: {
    doLoadLeagues() {
      AdminService.getLeaguesList().then((data) => {
        this.LeaguesList = data;
      }).catch((error) => {
        console.error("Error loading leagues:", error);
      });
    },
    truncateText(text, limit) {
      if (text === undefined || text === null) {
        return null
      } else {
        return String(text).length > limit ? String(text).substring(0, limit) + '...' : String(text);
      }
    },
    redirectToCreate() {
      this.$router.push({ name: 'LeagueCreate' }); // Navigate to the LeagueEdit route without params
    },
    async selectText(event) {
      const originalText = event.target.getAttribute('data-text');
      try {
        await navigator.clipboard.writeText(originalText);
        this.highlightElement(event.target);
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }
    },
    highlightElement(element) {
      this.removeHighlight();
      element.style.backgroundColor = 'yellow'; // Add highlight
      this.highlightedElement = element;
      setTimeout(this.removeHighlight, 10000); // Remove highlight after 10 seconds
    },
    removeHighlight() {
      if (this.highlightedElement) {
        this.highlightedElement.style.backgroundColor = ''; // Remove highlight
        this.highlightedElement = null;
      }
    },
    handleClickAnywhere() {
      this.removeHighlight()
    },
    toggleSort(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }
    }
  },
};
</script>
<style src="../../assets/style.css">
</style>
